<template id="Suspensions">
<Modele id="Suspensions"></Modele>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Suspensions',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Conduite/Suspensions.vue